import { render } from "./CurrencyComp.vue?vue&type=template&id=420471ec"
import script from "./CurrencyComp.vue?vue&type=script&lang=js"
export * from "./CurrencyComp.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__